import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Components
import Container, { StatItem, StatLabel, StatValue } from './components/Container';
import formatCurrency from '../../lib/formatCurrency';

const DisplayCartData = ({ cartItemsCount, cartTotalPrice }) => {
  const { t } = useTranslation();
  
  return (
    <Container>
      <StatItem>
        <i className="mdi mdi-cart-outline" />
        <div>
          <StatLabel>{t('itemsInCart')}</StatLabel>
          <StatValue>{cartItemsCount}</StatValue>
        </div>
      </StatItem>
      <StatItem>
        {/* <i className="mdi mdi-currency-eur" /> */}
        <div>
          <StatLabel>{t('totalValue')}</StatLabel>
          <StatValue>{formatCurrency(cartTotalPrice)}</StatValue>
        </div>
      </StatItem>
    </Container>
  );
};

DisplayCartData.propTypes = {
  cartItemsCount: PropTypes.number,
  cartTotalPrice: PropTypes.any,
};

export default DisplayCartData;
